// Main WidgetPreviews file - imports and re-exports all widget components
export { StarRating, PlatformIcon, sampleReviews } from './SharedComponents';

// Carousel widgets
export {
    CarouselWidgetPreview,
    SimpleCarouselPreview,
    ReviewsCarouselPreview
} from './CarouselWidgets';

// Grid widgets
export {
    GridPreview,
    MansoryPreview
} from './GridWidgets';

// Badge widgets
export {
    BadgePreview,
    FloatingBadgePreview
} from './BadgeWidgets';

// List widgets
export {
    ListPreview,
    SidebarWidgetPreview
} from './ListWidgets';

// Slider widgets
export {
    SliderPreview
} from './SliderWidgets';

// Dark theme widgets - Removed: All components now handle light/dark themes internally

// Import all components for the mapper
import {
    CarouselWidgetPreview,
    SimpleCarouselPreview,
    ReviewsCarouselPreview
} from './CarouselWidgets';

import {
    GridPreview,
    MansoryPreview
} from './GridWidgets';

import {
    BadgePreview,
    FloatingBadgePreview
} from './BadgeWidgets';

import {
    ListPreview,
    SidebarWidgetPreview
} from './ListWidgets';

import {
    SliderPreview
} from './SliderWidgets';

// Dark theme imports removed - components handle theming internally

// Widget preview mapper function
export const getWidgetPreviewComponent = (templateId) => {
    const widgetComponents = {
        'carousel-widget': CarouselWidgetPreview,
        'grid': GridPreview,
        'badge': BadgePreview,
        'simple-carousel': SimpleCarouselPreview,
        'floating-badge': FloatingBadgePreview,
        'reviews-carousel': ReviewsCarouselPreview,
        'list': ListPreview,
        'mansory': MansoryPreview,
        'sidebar-widget': SidebarWidgetPreview,
        'slider': SliderPreview,
        // Dark variants removed - components handle theming internally
    };

    return widgetComponents[templateId] || null;
}; 